export default __webpack_public_path__ + "static/5-68fe8102c0f675a5821ac0e13ab3c0df.png";